function objectToCSVByKey(data, key, withSpace = false) {
  if (!Array.isArray(data)) return '';
  return data.map(item => item[key]).join(withSpace ? ', ' : ',');
}

export default objectToCSVByKey;
